module.exports = __webpack_public_path__ + "img/soccer.0c99a1ed.svg";